import {Pipe, PipeTransform} from '@angular/core';
import {orderBy} from 'lodash-es';

@Pipe({
  name: 'values'
})
export class ValuesPipe implements PipeTransform {

  transform(value: any, args?: any): any[] {
    if (!value) {
      return [];
    }

    const values = Object.values(value);
    if (args) {
      return orderBy(values, args);
    }
    return values;
  }

}
